import { combineReducers } from 'redux';

import settingsReducer from './settings.reducer.js';
import themesReducer from './themes.reducers.js';
import zooReducer from './zoo.reducer.js';

export default combineReducers({
    settings: settingsReducer,
    theme: themesReducer,
    zoo: zooReducer
});
